var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3393_8584)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3393_8584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 6.25004C5.11822 6.25004 5.21725 6.21004 5.29725 6.13004C5.37725 6.05004 5.41711 5.95115 5.41683 5.83337C5.41683 5.71532 5.37683 5.61643 5.29683 5.53671C5.21683 5.45698 5.11794 5.41699 5.00016 5.41671C4.88211 5.41671 4.78322 5.45671 4.7035 5.53671C4.62377 5.61671 4.58377 5.7156 4.5835 5.83337C4.5835 5.95143 4.6235 6.05046 4.7035 6.13046C4.7835 6.21046 4.88239 6.25032 5.00016 6.25004ZM5.00016 4.58337C5.11822 4.58337 5.21725 4.54337 5.29725 4.46337C5.37725 4.38337 5.41711 4.28449 5.41683 4.16671V2.50004C5.41683 2.38199 5.37683 2.2831 5.29683 2.20337C5.21683 2.12365 5.11794 2.08365 5.00016 2.08337C4.88211 2.08337 4.78322 2.12337 4.7035 2.20337C4.62377 2.28337 4.58377 2.38226 4.5835 2.50004V4.16671C4.5835 4.28476 4.6235 4.38379 4.7035 4.46379C4.7835 4.54379 4.88239 4.58365 5.00016 4.58337ZM2.50016 7.50004L1.54183 8.45837C1.40989 8.59032 1.25877 8.6199 1.0885 8.54712C0.918219 8.47435 0.833219 8.34407 0.833497 8.15629V1.66671C0.833497 1.43754 0.915163 1.24143 1.0785 1.07837C1.24183 0.915318 1.43794 0.833652 1.66683 0.833374H8.3335C8.56266 0.833374 8.75891 0.915041 8.92225 1.07837C9.08558 1.24171 9.16711 1.43782 9.16683 1.66671V6.66671C9.16683 6.89587 9.0853 7.09212 8.92225 7.25546C8.75919 7.41879 8.56294 7.50032 8.3335 7.50004H2.50016ZM2.146 6.66671H8.3335V1.66671H1.66683V7.13546L2.146 6.66671Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3393_8584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3393_8584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.c215a99ed83287c77726e59ef32a82be.svg";
export { ForwardRef as ReactComponent };